var map = {
	"./Band_nato_black.jpg": "GngS",
	"./Band_nato_blackred.jpg": "5RW3",
	"./Band_nato_blue.jpg": "pgOn",
	"./Band_nato_edge_red.png": "d0Qz",
	"./Band_nato_norm.png": "07m8",
	"./Band_nato_orange.jpg": "7i19",
	"./Band_nato_red.jpg": "cavb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ock7";